import WebAnalytics from './WebAnalytics';
export * from './events';
export default WebAnalytics;
//# sourceMappingURL=index.js.map